export const TICKET = 'TICKET';